// extracted by mini-css-extract-plugin
export default {"root":"ChallengeTableItem_root__USG0q","name":"ChallengeTableItem_name__m8NRh","info":"ChallengeTableItem_info__kb304"};